// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__subContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 10px;
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__block {
  height: 250px;
  padding-left: 15px;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__toolbar {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__scrollBlock {
  max-height: 250px;
  overflow-y: auto;
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__listItemContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 270px;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__attributeLabel {
  width: -webkit-fill-available;
  width: -moz-available;
  width: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__listItem__actionContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__displayAttributeContainer {
  max-width: 300px;
  min-width: 270px;
  height: 250px;
  position: relative;
  border-left: 1px solid lightgrey;
  padding-left: 10px;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__attributeInfo > :nth-child(1) {
  margin-right: 5px;
  font-weight: bold;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__attributeInfo > :nth-child(2) {
  font-weight: normal;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__iconButton {
  border-radius: 4px;
  color: var(--colors-black);
  margin: 0 2px;
  transition: 0.2s;
  cursor: pointer;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__iconButton:hover {
  background-color: var(--colors-black);
  color: #ffffff;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__noAttributeItem {
  width: 270px;
  height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__choiceTypeInput_container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__choiceTypeInput_checkbox {
  min-width: 30px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
}

.app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__aggregationLabel {
  position: absolute;
  top: -13px;
  left: 0px;
  line-height: 12px;
  font-size: 11px;
  color: grey;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/FollowUp/CalculatedFields/CalculatedFields.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,6BAAc;EAAd,qBAAc;EAAd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAAc;EAAd,qBAAc;EAAd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,6BAAc;EAAd,qBAAc;EAAd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 600px;\n}\n\n.subContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-top: 10px;\n  width: stretch;\n}\n\n.block {\n  height: 250px;\n  padding-left: 15px;\n}\n\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.scrollBlock {\n  max-height: 250px;\n  overflow-y: auto;\n  width: stretch;\n}\n\n.listItemContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  width: 270px;\n}\n\n.attributeLabel {\n  width: stretch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.listItem__actionContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  flex-wrap: nowrap;\n}\n\n.displayAttributeContainer {\n  max-width: 300px;\n  min-width: 270px;\n  height: 250px;\n  position: relative;\n  border-left: 1px solid lightgrey;\n  padding-left: 10px;\n}\n\n.attributeInfo > :nth-child(1) {\n  margin-right: 5px;\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.attributeInfo > :nth-child(2) {\n  font-weight: normal;\n}\n\n.iconButton {\n  border-radius: 4px;\n  color: var(--colors-black);\n  margin: 0 2px;\n  transition: 0.2s;\n  cursor: pointer;\n}\n\n.iconButton:hover {\n  background-color: var(--colors-black);\n  color: #ffffff;\n}\n\n.noAttributeItem {\n  width: 270px;\n  height: 250px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.choiceTypeInput_container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.choiceTypeInput_checkbox {\n  min-width: 30px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: center;\n}\n\n.aggregationLabel {\n  position: absolute;\n  top: -13px;\n  left: 0px;\n  line-height: 12px;\n  font-size: 11px;\n  color: grey;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__container`,
	"subContainer": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__subContainer`,
	"block": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__block`,
	"toolbar": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__toolbar`,
	"scrollBlock": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__scrollBlock`,
	"listItemContainer": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__listItemContainer`,
	"attributeLabel": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__attributeLabel`,
	"listItem__actionContainer": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__listItem__actionContainer`,
	"displayAttributeContainer": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__displayAttributeContainer`,
	"attributeInfo": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__attributeInfo`,
	"iconButton": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__iconButton`,
	"noAttributeItem": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__noAttributeItem`,
	"choiceTypeInput_container": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__choiceTypeInput_container`,
	"choiceTypeInput_checkbox": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__choiceTypeInput_checkbox`,
	"aggregationLabel": `app-pages-Project-Settings-FollowUp-CalculatedFields-___CalculatedFields-module__aggregationLabel`
};
export default ___CSS_LOADER_EXPORT___;
